// Number/date formatting for the institutional finance look (§6). USD.
// Negatives render in red parentheses where the component opts in via signClass.

export function formatUSD(value: number | null | undefined, opts: { compact?: boolean } = {}): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  const abs = Math.abs(value);
  const fmt = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: opts.compact ? "compact" : "standard",
    maximumFractionDigits: opts.compact ? 1 : 0,
    minimumFractionDigits: 0,
  });
  const body = fmt.format(abs);
  return value < 0 ? `(${body})` : body;
}

export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return new Intl.NumberFormat("en-US").format(value);
}

// pct: pass a ratio (0.66) → "66.0%". Pass already-percent? use isRatio=false.
export function formatPct(
  value: number | null | undefined,
  opts: { isRatio?: boolean; digits?: number } = {}
): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  const { isRatio = true, digits = 1 } = opts;
  const pct = isRatio ? value * 100 : value;
  return `${pct.toFixed(digits)}%`;
}

export function isNegative(value: number | null | undefined): boolean {
  return typeof value === "number" && value < 0;
}

// Tailwind class for a signed monetary value.
export function signClass(value: number | null | undefined): string {
  return isNegative(value) ? "text-critical" : "text-ink-900";
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(d);
}
